

import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    //'Authorization': 'Bearer ' + localStorage.getItem('accesstoken')
  })
 
};

@Injectable()
export class BaseService {
  debugger
  apiURL: string;
  constructor(private http: HttpClient, private router: Router, public toastr: ToastrService) {
    this.apiURL = environment.apiurl;
  }
 
  //-------Add entity----------------------
  postData(entity: any, url: string):any {
    var body = JSON.stringify(entity);
    return this.http.post(this.apiURL + url, entity, httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  //-------Add entity----------------------
  getdatalistWithbody(entity: any, url: string): Observable<any[]> {
    var body = JSON.stringify(entity);
  //  return this.http.post(this.apiURL + url, entity, httpOptions)
    return this.http.get<any[]>(this.apiURL + url, httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }
   //-------Update entity----------------------       
  putData(entity: any, url: string) {
    var body = JSON.stringify(entity);
    return this.http.put(this.apiURL + url, entity, httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
      
  }
 
    //-------get data----------------------       
  getDataList(url: string): Observable<any[]> {
    return this.http.get<any[]>(this.apiURL + url, httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
      //.pipe(
      ////  catchError(this.handleError('getCountry', []))
      //);
  }
  ////-------Delete entity----------------------
  deleteData(entity: any, url: string) {
    var bodyData = JSON.stringify(entity);
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //'Authorization': 'Bearer ' + localStorage.getItem('accesstoken')
      }),
      body: bodyData


    };
    //var options = new RequestOptions({headers: httpOptions, body: bodydata});
    return this.http.delete<any>(this.apiURL + url, httpOptions1)
      .pipe(catchError((error) => this.handleError(error)));
    //  , { 
    //  headers: httpOptions,
    //  observe: body,
     
    //  responseType?: 'json',
     
      //}
  //  )
    
  }

  ////-------Get Klist entity----------------------
  //getDataKlist(): Observable<any> {
  //  var body = null;
  // // var this.headerOptions = new Headers({ 'Content-Type': 'application/json' });
  //  var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: this.headerOptions });
  //  return this.http.post(this.apiURL + 'KGetListAll/', body, requestOptions).map((res: Response) => res.json());
  //}

  //private handleError(error: Response) {
  //  return Observable.throw(error.statusText);
  //}
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    }
    else {
      if (!error.status) {
        this.toastr.error('Can not connect Server');
        return throwError('ErrorFromWebAPI');
      }
      else if (error.status === 401) {
        this.toastr.error('You are unauthorized, please try to login');
        //this.UserLogoutLog();
        console.log(error);
        this.router.navigate(['/pages/login']);
      }
      else if (error.status === 404) {
        this.toastr.error(error["message"]);
        return throwError('ErrorFromWebAPI');
      }
      else if (error.status === 500) {
        this.toastr.error(error.error["message"]);
        console.error(`ErrorFromWebAPI code ${error.status}, ` + `body was: ${error.error}`);
        return throwError(error);
      }
      else if (error.status === 400) {
        console.error(`ErrorFromWebAPI code ${error.status}, ` + `body was: ${error.error.ModelState}`);
        return throwError(error);
      }
      else {
        this.toastr.error(error.error);
        console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
      }
    }
    return throwError('Something bad happened. Please try again later.');
  }

  UserLogoutLog() {
    const traceId = localStorage.getItem('traceId');
    if (traceId) {
      this.postData(null, `UserTracking/Logout?traceId=${traceId}`).subscribe((res: any) => {
        console.log(res)
      },
      error => {
        console.log('error: ' + error)
      });
    }
  }
}
